<template>
  <div class="deviation-alarm-page" style="height: calc(100vh - 135px); overflow: auto; padding-right: 8px;">
    <!-- 上方报表（统计看板 / 趋势TOP分析）暂隐藏 -->
    <div v-if="false">
    <!-- 统计看板 -->
    <el-row :gutter="12" class="stat-dashboard">
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card stat-total">
          <div class="stat-icon-wrap"><i class="el-icon-alarm-clock"></i></div>
          <div class="stat-content">
            <div class="stat-label">近7天告警总数</div>
            <div class="stat-value">{{ stats.overview.totalLast7Days }}</div>
            <div class="stat-trend up">较上周 +12%</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card stat-ongoing">
          <div class="stat-icon-wrap"><i class="el-icon-bell"></i></div>
          <div class="stat-content">
            <div class="stat-label">进行中告警</div>
            <div class="stat-value pulse">{{ stats.overview.ongoingNow }}</div>
            <div class="stat-trend warn">需及时处理</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card stat-handled">
          <div class="stat-icon-wrap"><i class="el-icon-circle-check"></i></div>
          <div class="stat-content">
            <div class="stat-label">已处置数</div>
            <div class="stat-value">{{ stats.overview.handledCount }}</div>
            <div class="stat-trend">处置率 {{ handledRate }}%</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card stat-fp">
          <div class="stat-icon-wrap"><i class="el-icon-warning-outline"></i></div>
          <div class="stat-content">
            <div class="stat-label">误报数 / 误报率</div>
            <div class="stat-value">{{ stats.overview.falsePositiveCount }} <span class="unit">/ {{ stats.overview.falsePositiveRate }}%</span></div>
            <div class="stat-trend" :class="stats.overview.falsePositiveRate > 15 ? 'warn' : ''">阈值调优参考</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 趋势 & TOP分析 -->
    <el-row :gutter="12" style="margin-top: 12px;">
      <el-col :span="14">
        <el-card shadow="never" class="chart-card">
          <div slot="header" class="card-header">
            <span class="card-title"><i class="el-icon-data-line"></i> 近7天告警趋势</span>
          </div>
          <div class="trend-chart">
            <svg :viewBox="trendViewBox" preserveAspectRatio="none" class="trend-svg">
              <defs>
                <linearGradient id="gradTotal" x1="0" x2="0" y1="0" y2="1">
                  <stop offset="0%" stop-color="#409EFF" stop-opacity="0.35"/>
                  <stop offset="100%" stop-color="#409EFF" stop-opacity="0"/>
                </linearGradient>
              </defs>
              <g class="grid-lines">
                <line v-for="i in 4" :key="'h'+i" :x1="paddingX" :x2="chartW - paddingX" :y1="yAt(i*25)" :y2="yAt(i*25)" stroke="#EBEEF5" />
              </g>
              <polygon :points="areaPoints" fill="url(#gradTotal)" />
              <polyline :points="linePoints" fill="none" stroke="#409EFF" stroke-width="2.5" />
              <g v-for="(d, i) in stats.trend" :key="'dot'+i">
                <circle :cx="xAt(i)" :cy="yAt(d.total)" r="4.5" fill="#fff" stroke="#409EFF" stroke-width="2"/>
                <text :x="xAt(i)" :y="yAt(d.total) - 10" text-anchor="middle" class="dot-label">{{ d.total }}</text>
              </g>
              <g v-for="(d, i) in stats.trend" :key="'xlab'+i">
                <text :x="xAt(i)" :y="chartH - 4" text-anchor="middle" class="x-label">{{ d.date }}</text>
              </g>
            </svg>
            <div class="legend-row">
              <span class="legend-item"><span class="dot blue"></span> 总数</span>
              <span class="legend-item"><span class="dot orange"></span> 进行中</span>
              <span class="legend-item"><span class="dot green"></span> 已回归</span>
              <span class="legend-item"><span class="dot gray"></span> 误报</span>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card shadow="never" class="chart-card">
          <div slot="header" class="card-header">
            <span class="card-title"><i class="el-icon-s-promotion"></i> TOP偏离车辆</span>
          </div>
          <div class="top-list">
            <div v-for="(v, i) in stats.topVehicles" :key="'tv'+i" class="top-item">
              <div class="top-rank" :class="'rk'+(i+1)">{{ i + 1 }}</div>
              <div class="top-info">
                <div class="top-name">{{ v.plateNo }}</div>
                <div class="top-bar-wrap">
                  <div class="top-bar" :style="{ width: (v.count / maxTopVCount * 100) + '%' }"></div>
                </div>
              </div>
              <div class="top-count">
                <span class="num">{{ v.count }}</span>
                <span class="unit">次</span>
                <div class="sub">偏离 {{ v.mileage }}km</div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card shadow="never" class="chart-card">
          <div slot="header" class="card-header">
            <span class="card-title"><i class="el-icon-guide"></i> 告警线路分布</span>
          </div>
          <div class="pie-wrap">
            <svg viewBox="0 0 200 200" class="pie-svg">
              <g transform="translate(100, 100)">
                <path v-for="(seg, i) in pieSegments" :key="'p'+i"
                  :d="seg.d" :fill="seg.color" stroke="#fff" stroke-width="2"/>
              </g>
            </svg>
            <div class="pie-legend">
              <div v-for="(r, i) in stats.topRoutes" :key="'rl'+i" class="pie-legend-item">
                <span class="color-box" :style="{ background: pieColors[i % pieColors.length] }"></span>
                <span class="pl-name">{{ r.routeName }}</span>
                <span class="pl-pct">{{ r.pct }}%</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    </div>

    <!-- 告警列表 -->
    <el-card class="list-card" shadow="never" style="margin-top: 12px;">
      <div slot="header" class="card-header">
        <div class="search-bar">
          <el-input
            size="small"
            v-model="searchForm.keyword"
            placeholder="搜索车牌 / 线路 / 驾驶员"
            clearable
            style="width: 260px;"
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
            prefix-icon="el-icon-search"
          />
          <el-select
            v-model="searchForm.eventStatus"
            size="small"
            placeholder="事件状态"
            clearable
            style="width: 120px; margin-left: 10px;"
            @change="handleSearch"
          >
            <el-option label="全部" :value="-1" />
            <el-option label="进行中" :value="0" />
            <el-option label="已回归" :value="1" />
          </el-select>
          <el-select
            v-model="searchForm.handleStatus"
            size="small"
            placeholder="处置状态"
            clearable
            style="width: 120px; margin-left: 10px;"
            @change="handleSearch"
          >
            <el-option label="全部" :value="-1" />
            <el-option label="处理中" :value="0" />
            <el-option label="已处理" :value="1" />
            <el-option label="误报" :value="2" />
          </el-select>
          <el-date-picker
            v-model="dateRange"
            size="small"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 260px; margin-left: 10px;"
            @change="handleSearch"
          />
          <el-button size="small" icon="el-icon-refresh" @click="refreshAll" style="margin-left: 10px;">刷新</el-button>
        </div>
      </div>

      <el-table
        v-loading="loading"
        :data="listData"
        style="width: 100%;"
        :max-height="'calc(100vh - 620px)'"
        border
        highlight-current-row
   
      >
        <el-table-column type="index" label="#" width="50" align="center" />
        <el-table-column label="车牌" width="110" align="center">
          <template slot-scope="{ row }">
            <span class="plate-tag">{{ row.plateNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="routeName" label="线路" min-width="180" show-overflow-tooltip />
        <!-- <el-table-column label="告警级别" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="levelTag(row.alarmLevel)" effect="dark">{{ row.alarmLevelText }}</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column prop="triggerTime" label="开始时间" width="160" align="center" />
        <el-table-column label="持续时长" width="130" align="center">
          <template slot-scope="{ row }">
            <span :class="{ ongoing: row.eventStatus === 0 }">{{ row.durationText }}</span>
          </template>
        </el-table-column>
        <el-table-column label="最大偏离" width="110" align="center">
          <template slot-scope="{ row }">
            <span :class="deviationClass(row)">{{ row.maxDeviationText }}</span>
          </template>
        </el-table-column>
        <el-table-column label="偏离里程" width="110" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.offRouteMileageText }}</span>
          </template>
        </el-table-column>
        <el-table-column label="事件状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="eventStatusTag(row.eventStatus)">
              <span v-if="row.eventStatus === 0" class="blink-dot"></span>
              {{ row.eventStatusText }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="处置状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="handleStatusTag(row.handleStatus)">{{ row.handleStatusText }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="driverName" label="驾驶员" width="80" align="center" />
        <!-- <el-table-column label="操作" width="220" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-button size="mini" type="text" @click="openDetail(row)">查看详情</el-button>
            <el-button size="mini" type="text" v-if="row.handleStatus !== 1 && row.handleStatus !== 2"
              @click="quickHandle(row, 1)">确认违规</el-button>
            <el-button size="mini" type="text" style="color:#E6A23C;" v-if="row.handleStatus === 0 || row.handleStatus === 1"
              @click="quickHandle(row, 2)">标记误报</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <div class="pagination-wrap">
        <kl-pagination
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>

    <!-- 详情抽屉 -->
    <el-drawer
      title="偏离告警详情"
      :visible.sync="detailVisible"
      size="780px"
      direction="rtl"
      class="alarm-detail-drawer"
      :before-close="beforeCloseDetail"
    >
      <div v-if="currentEvent" class="detail-root" v-loading="detailLoading">
        <!-- 头部信息卡 -->
        <div class="event-header-card" :class="'lv-' + currentEvent.alarmLevel">
          <div class="ehc-left">
            <div class="ehc-level">
              <span class="level-badge">{{ currentEvent.alarmLevelText }}</span>
              <el-tag size="mini" :type="eventStatusTag(currentEvent.eventStatus)" style="margin-left:8px;">
                <span v-if="currentEvent.eventStatus === 0" class="blink-dot"></span>
                {{ currentEvent.eventStatusText }}
              </el-tag>
            </div>
            <div class="ehc-title">
              <span class="plate-big">{{ currentEvent.plateNo }}</span>
              <span class="sep">·</span>
              <span class="route">{{ currentEvent.routeName }}</span>
            </div>
            <div class="ehc-meta">
              <i class="el-icon-user"></i> {{ currentEvent.driverName }} · {{ currentEvent.driverPhone }}
              <span class="meta-sep">|</span>
              <i class="el-icon-time"></i> 触发 {{ currentEvent.triggerTime }}
            </div>
          </div>
          <div class="ehc-right">
            <div class="ehc-stat">
              <div class="ehc-num">{{ currentEvent.maxDeviationText }}</div>
              <div class="ehc-label">最大偏离</div>
            </div>
            <div class="ehc-stat">
              <div class="ehc-num">{{ currentEvent.durationText }}</div>
              <div class="ehc-label">持续时长</div>
            </div>
            <div class="ehc-stat">
              <div class="ehc-num">{{ currentEvent.offRouteMileageText }}</div>
              <div class="ehc-label">偏离里程</div>
            </div>
          </div>
        </div>

        <!-- 地图区域：基准线 + 实际轨迹 -->
        <div class="map-section">
          <div class="section-title"><i class="el-icon-map-location"></i> 地图叠加：基准线 vs 实际轨迹</div>
          <div class="map-canvas-wrap" v-loading="replayLoading">
            <KingLongMap
              ref="replayMap"
              :mapId="'alarmReplayMap'"
              @LoadCompleted="onReplayMapLoaded"
            />
            <div v-if="!replayData && !replayLoading" class="map-empty-overlay">
              <i class="el-icon-data-line"></i>
              <div>轨迹回放数据加载中...</div>
            </div>
            <div class="map-legend">
              <span class="lg-item"><span class="lg-line blue"></span>基准线</span>
              <span class="lg-item"><span class="lg-buf"></span>缓冲带</span>
              <span class="lg-item"><span class="lg-line gray"></span>实际轨迹</span>
              <span class="lg-item"><span class="lg-line red-bold"></span>偏离段</span>
              <span class="lg-item"><span class="lg-dot green"></span>起点</span>
              <span class="lg-item"><span class="lg-dot red"></span>最大偏离</span>
              <span class="lg-item"><span class="lg-dot orange"></span>当前车辆</span>
            </div>
          </div>

          <!-- 回放控制条 -->
          <div class="replay-control" v-if="replayData">
            <el-button size="mini" icon="el-icon-video-play" :type="isPlaying ? 'warning' : 'primary'" @click="togglePlay">
              {{ isPlaying ? '暂停' : '播放' }}
            </el-button>
            <el-button size="mini" icon="el-icon-refresh-left" @click="resetPlay">重置</el-button>
            <el-slider
              v-model="playIdx"
              :min="0"
              :max="replayData.actualTrack.length - 1"
              :show-tooltip="false"
              style="flex: 1; margin: 0 16px;"
              @change="onPlayIdxChange"
            />
            <span class="play-time">{{ playTimeLabel }}</span>
          </div>

          <!-- 偏离距离曲线 -->
          <div class="curve-section" v-if="replayData">
            <svg :viewBox="curveViewBox" preserveAspectRatio="none" class="curve-svg">
              <line :x1="padL" :x2="curveW - padR" :y1="curveYAt(replayData.thresholdM)" :y2="curveYAt(replayData.thresholdM)"
                stroke="#F56C6C" stroke-width="1.2" stroke-dasharray="5 3"/>
              <text :x="curveW - padR" :y="curveYAt(replayData.thresholdM) - 4" class="th-label" text-anchor="end">阈值 {{ replayData.thresholdM }}m</text>
              <polyline :points="devCurvePoints" fill="none" stroke="#409EFF" stroke-width="2"/>
              <circle :cx="curveXAt(playIdx)" :cy="curveYAt(currentDev)" r="4" fill="#E6A23C" stroke="#fff" stroke-width="2"/>
            </svg>
            <div class="curve-meta">
              <span>当前点偏离：<b :class="currentDev > replayData.thresholdM ? 'dev-bad' : 'dev-ok'">{{ currentDev }} m</b></span>
              <span>速度：<b>{{ currentSpeed }} km/h</b></span>
            </div>
          </div>
        </div>

        <!-- 三个地址卡 -->
        <el-row :gutter="10" class="addr-row">
          <el-col :span="8">
            <div class="addr-card">
              <div class="addr-icon start"><i class="el-icon-location"></i></div>
              <div class="addr-body">
                <div class="addr-label">起始偏离点</div>
                <div class="addr-text">{{ currentEvent.startAddress }}</div>
                <div class="addr-coord">{{ fmtPt([currentEvent.startLng, currentEvent.startLat]) }}</div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="addr-card">
              <div class="addr-icon max"><i class="el-icon-warning"></i></div>
              <div class="addr-body">
                <div class="addr-label">最大偏离点</div>
                <div class="addr-text">{{ currentEvent.maxAddress }}</div>
                <div class="addr-coord">{{ fmtPt([currentEvent.maxLng, currentEvent.maxLat]) }}</div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="addr-card">
              <div class="addr-icon end"><i class="el-icon-location-outline"></i></div>
              <div class="addr-body">
                <div class="addr-label">结束/当前位置</div>
                <div class="addr-text">{{ currentEvent.endAddress || '（持续偏离中）' }}</div>
                <div class="addr-coord">{{ currentEvent.endLng ? fmtPt([currentEvent.endLng, currentEvent.endLat]) : '—' }}</div>
              </div>
            </div>
          </el-col>
        </el-row>

        <!-- 处置区 -->
        <div class="handle-section">
          <div class="section-title"><i class="el-icon-edit-outline"></i> 告警处置</div>
          <el-descriptions :column="2" border size="small" v-if="currentEvent.handleStatus > 0">
            <el-descriptions-item label="处置状态">
              <el-tag size="mini" :type="handleStatusTag(currentEvent.handleStatus)">{{ currentEvent.handleStatusText }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处置人">{{ currentEvent.handlerName || '—' }}</el-descriptions-item>
            <el-descriptions-item label="处置时间" :span="2">{{ currentEvent.handleTime || '—' }}</el-descriptions-item>
            <el-descriptions-item label="处置备注" :span="2">{{ currentEvent.handleRemark || '—' }}</el-descriptions-item>
          </el-descriptions>

          <el-form v-else label-width="90px" size="small" class="handle-form">
            <el-form-item label="处置方式">
              <el-radio-group v-model="handleForm.handleStatus">
                <el-radio-button :label="1">确认违规</el-radio-button>
                <el-radio-button :label="2">标记误报</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="处置备注">
              <el-input v-model="handleForm.handleRemark" type="textarea" :rows="2" placeholder="请输入处置备注，方便后续审计..." />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-check" @click="submitHandle">提交处置</el-button>
              <el-button icon="el-icon-phone" @click="contactDriver">联系司机</el-button>
              <el-button type="warning" icon="el-icon-plus" @click="openAddExempt">将最大偏离点添加为豁免点</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-drawer>

    <!-- 添加豁免点 dialog -->
    <el-dialog title="添加豁免点" :visible.sync="exemptDialogVisible" width="480px" append-to-body>
      <el-form label-width="100px" size="small" v-if="exemptForm">
        <el-form-item label="名称">
          <el-input v-model="exemptForm.name" placeholder="例：XX加油站 / 施工绕行区域" />
        </el-form-item>
        <el-form-item label="豁免半径">
          <el-slider v-model="exemptForm.radiusM" :min="50" :max="1000" :step="50" show-input />
          <div style="font-size:12px;color:#909399;">车辆进入该半径范围内，不触发偏离告警</div>
        </el-form-item>
        <el-form-item label="坐标">
          <el-input :value="`${exemptForm.lng}, ${exemptForm.lat}`" disabled />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="exemptDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitExempt">确认添加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  mockGetEventDetail,
  mockGetEventReplay,
  mockHandleEvent,
  mockAddExemptPoint,
  mockGetEventStatistics
} from '../_mock/routeDeviationMock.js';
import KingLongMap from '@/components/KingLongMap.vue';

export default {
  name: 'DeviationAlarm',
  components: { KingLongMap },
  data() {
    return {
      loading: false,
      listData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: { keyword: '', eventStatus: -1, handleStatus: -1 },
      dateRange: null,
      stats: {
        overview: { totalLast7Days: 0, ongoingNow: 0, handledCount: 0, falsePositiveCount: 0, falsePositiveRate: 0 },
        trend: [],
        topVehicles: [],
        topRoutes: []
      },
      detailVisible: false,
      detailLoading: false,
      currentEvent: null,
      replayLoading: false,
      replayData: null,
      replayMapReady: false,
      // 回放控制
      isPlaying: false,
      playIdx: 0,
      playTimer: null,
      // 处置
      handleForm: { handleStatus: 1, handleRemark: '' },
      exemptDialogVisible: false,
      exemptForm: null
    };
  },
  computed: {
    handledRate() {
      const t = this.stats.overview.totalLast7Days;
      return t ? Math.round(this.stats.overview.handledCount / t * 100) : 0;
    },
    maxTopVCount() {
      const arr = this.stats.topVehicles || [];
      return arr.length ? Math.max(...arr.map(x => x.count)) : 1;
    },
    // 趋势图
    trendViewBox() { return `0 0 ${this.chartW} ${this.chartH}`; },
    chartW() { return 560; },
    chartH() { return 220; },
    paddingX() { return 36; },
    linePoints() {
      const d = this.stats.trend;
      return d.map((p, i) => `${this.xAt(i)},${this.yAt(p.total)}`).join(' ');
    },
    areaPoints() {
      const d = this.stats.trend;
      if (!d.length) return '';
      const pts = d.map((p, i) => `${this.xAt(i)},${this.yAt(p.total)}`);
      const lastIdx = d.length - 1;
      return `${this.xAt(0)},${this.chartH - 20} ${pts.join(' ')} ${this.xAt(lastIdx)},${this.chartH - 20}`;
    },
    // 饼图
    pieColors() { return ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399']; },
    pieSegments() {
      const routes = this.stats.topRoutes || [];
      let a0 = -Math.PI / 2;
      return routes.map((r, i) => {
        const a = r.pct / 100 * Math.PI * 2;
        const a1 = a0 + a;
        const large = a > Math.PI ? 1 : 0;
        const r0 = 0, r1 = 80;
        const x0 = Math.cos(a0) * r0, y0 = Math.sin(a0) * r0;
        const x1 = Math.cos(a0) * r1, y1 = Math.sin(a0) * r1;
        const x2 = Math.cos(a1) * r1, y2 = Math.sin(a1) * r1;
        const x3 = Math.cos(a1) * r0, y3 = Math.sin(a1) * r0;
        const d = `M ${x0} ${y0} L ${x1} ${y1} A ${r1} ${r1} 0 ${large} 1 ${x2} ${y2} L ${x3} ${y3} A ${r0} ${r0} 0 ${large} 0 ${x0} ${y0} Z`;
        a0 = a1;
        return { d, color: this.pieColors[i % this.pieColors.length] };
      });
    },
    // 当前播放点信息
    currentPlayPoint() {
      if (!this.replayData || !this.replayData.actualTrack.length) return null;
      return this.replayData.actualTrack[Math.min(this.playIdx, this.replayData.actualTrack.length - 1)];
    },
    currentDev() {
      const p = this.currentPlayPoint;
      return p ? (p.dev || 0) : 0;
    },
    currentSpeed() {
      const p = this.currentPlayPoint;
      return p ? (p.spd || 0) : 0;
    },
    playTimeLabel() {
      const t = this.currentPlayPoint?.t || 0;
      const m = Math.floor(t / 60), s = t % 60;
      return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    },
    // 曲线图
    curveW() { return 700; },
    curveH() { return 120; },
    padL() { return 40; },
    padR() { return 10; },
    curveViewBox() { return `0 0 ${this.curveW} ${this.curveH}`; },
    devCurvePoints() {
      if (!this.replayData) return '';
      return this.replayData.actualTrack.map((p, i) => `${this.curveXAt(i)},${this.curveYAt(p.dev)}`).join(' ');
    }
  },
  watch: {
    replayData() {
      this.$nextTick(() => this.drawReplayMap());
    },
    playIdx() {
      this.updatePlayMarker();
    }
  },
  created() {
    // 默认查询最近一周
    const pad = n => String(n).padStart(2, '0');
    const fmt = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const now = new Date();
    const start = new Date(now.getTime() - 6 * 24 * 3600 * 1000);
    this.dateRange = [fmt(start), fmt(now)];
  },
  mounted() {
    this.loadStats();
    this.loadList();
  },
  beforeDestroy() {
    this.stopPlay();
  },
  methods: {
    // 坐标轴
    xAt(i) {
      const n = Math.max(1, this.stats.trend.length - 1);
      return this.paddingX + (this.chartW - 2 * this.paddingX) * (i / n);
    },
    yAt(v) {
      const maxV = Math.max(30, ...this.stats.trend.map(x => x.total));
      return (this.chartH - 20) * (1 - v / maxV) + 6;
    },
    curveXAt(i) {
      const n = Math.max(1, (this.replayData?.actualTrack?.length || 1) - 1);
      return this.padL + (this.curveW - this.padL - this.padR) * (i / n);
    },
    curveYAt(v) {
      const maxV = Math.max((this.replayData?.thresholdM || 300) * 1.5, v * 1.2, 100);
      return 10 + (this.curveH - 20) * (1 - v / maxV);
    },
    // Tag helpers
    levelTag(l) { return l === 3 ? 'danger' : l === 2 ? 'warning' : 'info'; },
    eventStatusTag(s) {
      if (s === 0) return 'danger';
      if (s === 1) return 'success';
      return 'info';
    },
    handleStatusTag(s) {
      if (s === 0) return 'warning';
      if (s === 1) return 'success';
      if (s === 2) return 'info';
      return 'info';
    },
    deviationClass(row) {
      const ratio = (row.maxDeviationM || 0) / (row.thresholdM || 1);
      if (ratio >= 3) return 'dev-critical';
      if (ratio >= 1.5) return 'dev-bad';
      return 'dev-warn';
    },
    fmtPt(p) {
      if (!p || p.length < 2) return '—';
      return `${p[0].toFixed(4)}, ${p[1].toFixed(4)}`;
    },
    geomToSvg(geom, scale = 1) {
      return (geom || []).map(p => `${p[0] * (1/scale)},${-p[1] * (1/scale)}`).join(' ');
    },
    loadStats() {
      mockGetEventStatistics().then(res => {
        if (res.code === 200) this.stats = res.data;
      });
    },
    loadList() {
      this.loading = true;
      const [beginDate, endDate] = this.dateRange || [];
      this.$api.QueryDeviationRecords({
        QueryData: this.searchForm.keyword || '',
        BeginDate: beginDate || '',
        EndDate: endDate || '',
        EventStatus: this.searchForm.eventStatus ?? -1,
        DisposalStatus: this.searchForm.handleStatus ?? -1,
        PageNo: this.currentPage,
        PageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.listData = (res.data || []).map(this.mapDeviationRecord);
          this.total = res.recordsTotal || 0;
        }
        this.loading = false;
      }).catch(() => { this.loading = false; });
    },
    // 接口记录 → 列表展示结构
    mapDeviationRecord(item) {
      const durationS = Math.round(item.Duration || 0);
      const h = Math.floor(durationS / 3600);
      const m = Math.round((durationS % 3600) / 60);
      const durationText = durationS < 60 ? (durationS + '秒') : (h > 0 ? (m ? `${h}小时${m}分` : `${h}小时`) : `${m}分钟`);
      const maxDev = Number(item.MaxDeviationDegree || 0);
      const maxDeviationText = maxDev >= 1000 ? (maxDev / 1000).toFixed(2) + ' 公里' : (maxDev % 1 === 0 ? String(maxDev) : maxDev.toFixed(1)) + ' 米';
      const offKm = Number(item.DeviationDistance || 0);
      const eventStatusText = { 0: '进行中', 1: '已回归' }[item.EventStatus] || '已结束';
      const handleStatusText = { 0: '处理中', 1: '已处理', 2: '误报' }[item.DisposalStatus] || '未处理';
      return {
        plateNo: item.CarNo,
        routeName: item.RouteName,
        triggerTime: item.BeginTime,
        durationText: durationS ? durationText : '—',
        maxDeviationM: maxDev,
        thresholdM: 300, // 接口未返回阈值，展示用默认 300
        maxDeviationText,
        offRouteMileageM: Math.round(offKm * 1000),
        offRouteMileageText: offKm ? offKm.toFixed(2) + ' 公里' : '—',
        eventStatus: item.EventStatus,
        eventStatusText,
        handleStatus: item.DisposalStatus,
        handleStatusText,
        driverName: item.DriverName
      };
    },
    refreshAll() {
      this.loadStats();
      this.loadList();
    },
    handleSearch() { this.currentPage = 1; this.loadList(); },
    handlePageChange(p) { this.currentPage = p; this.loadList(); },
    handleSizeChange(s) { this.pageSize = s; this.currentPage = 1; this.loadList(); },
    openDetail(row) {
      this.currentEvent = null;
      this.replayData = null;
      this.stopPlay();
      this.detailVisible = true;
      this.detailLoading = true;
      mockGetEventDetail(row.id).then(res => {
        this.detailLoading = false;
        if (res.code === 200) {
          this.currentEvent = res.data;
          this.loadReplay(row.id);
        }
      }).catch(() => { this.detailLoading = false; });
    },
    beforeCloseDetail() {
      this.stopPlay();
    },
    loadReplay(id) {
      this.replayLoading = true;
      this.playIdx = 0;
      mockGetEventReplay(id).then(res => {
        this.replayLoading = false;
        if (res.code === 200) {
          this.replayData = res.data;
        }
      }).catch(() => { this.replayLoading = false; });
    },
    togglePlay() {
      if (this.isPlaying) this.stopPlay();
      else this.startPlay();
    },
    startPlay() {
      this.stopPlay();
      this.isPlaying = true;
      this.playTimer = setInterval(() => {
        const max = (this.replayData?.actualTrack?.length || 1) - 1;
        if (this.playIdx < max) {
          this.playIdx++;
        } else {
          this.stopPlay();
        }
      }, 250);
    },
    stopPlay() {
      this.isPlaying = false;
      if (this.playTimer) { clearInterval(this.playTimer); this.playTimer = null; }
    },
    resetPlay() {
      this.stopPlay();
      this.playIdx = 0;
    },
    onPlayIdxChange() {},
    // ====== 回放地图 ======
    onReplayMapLoaded() {
      this.replayMapReady = true;
      this.$nextTick(() => this.drawReplayMap());
    },
    drawReplayMap() {
      const map = this.$refs.replayMap;
      if (!map || !this.replayMapReady) return;
      map.clearAll();
      const rd = this.replayData;
      if (!rd) return;
      const th = rd.thresholdM || 300;
      // 缓冲区 - 对基准线关键点画阈值圈（示意）
      const routeArr = rd.route || [];
      if (routeArr.length) {
        const step = Math.max(1, Math.floor(routeArr.length / 10));
        for (let i = 0; i < routeArr.length; i += step) {
          const [lng, lat] = routeArr[i];
          map.addCircle('buf_' + i, { lng, lat }, th,
            1, 'rgba(64,158,255,0.35)', 'rgba(64,158,255,0.08)', false);
        }
      }
      // 基准线
      const routeCoords = routeArr.map(p => ({ lng: p[0], lat: p[1] }));
      if (routeCoords.length) {
        map.addPolyline('rep_route', '基准线', routeCoords, 5, '#409EFF', false, true);
      }
      // 实际轨迹 - 正常段（偏离小于阈值）
      const track = rd.actualTrack || [];
      if (track.length) {
        const normalSeg = track.filter(p => p.dev < th);
        const devSeg = track.filter(p => p.dev >= th);
        if (normalSeg.length) {
          map.addPolyline('rep_track', '实际轨迹', normalSeg.map(p => ({ lng: p.lng, lat: p.lat })),
            3, '#909399', false, false);
        }
        // 偏离段（重点强调）
        if (devSeg.length) {
          map.addPolyline('rep_devtrack', '偏离段', devSeg.map(p => ({ lng: p.lng, lat: p.lat })),
            6, '#F56C6C', false, false);
        }
      }
      // 起点
      if (rd.startPoint) {
        map.addMarker('rep_start', '起点', rd.startPoint[0], rd.startPoint[1],
          null, null, 14, 14, { color: '#67C23A' });
      }
      // 最大偏离点
      if (rd.maxPoint) {
        map.addMarker('rep_max', '最大偏离点', rd.maxPoint[0], rd.maxPoint[1],
          null, null, 18, 18, { color: '#F56C6C' });
      }
      // 终点
      if (rd.endPoint) {
        map.addMarker('rep_end', '终点', rd.endPoint[0], rd.endPoint[1],
          null, null, 14, 14, { color: '#909399' });
      }
      // 播放marker（初始位置）
      this.updatePlayMarker();
    },
    updatePlayMarker() {
      const map = this.$refs.replayMap;
      if (!map || !this.replayMapReady || !this.currentPlayPoint) return;
      const { lng, lat } = this.currentPlayPoint;
      map.removeMarkerById('rep_play');
      map.addMarker('rep_play', '车辆', lng, lat,
        null, null, 20, 20, { color: '#E6A23C' });
    },
    quickHandle(row, status) {
      const label = { 2: '确认违规', 3: '忽略', 4: '标记误报' }[status];
      this.$confirm(`确定${label}该告警（${row.plateNo} @ ${row.routeName}）？`, '处置确认', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        mockHandleEvent({
          id: row.id,
          handleStatus: status,
          handleRemark: `快捷${label}`,
          handlerId: 1, handlerName: '当前操作员'
        }).then(res => {
          if (res.code === 200) {
            this.$message.success('处置成功');
            this.refreshAll();
          }
        });
      }).catch(() => {});
    },
    submitHandle() {
      mockHandleEvent({
        id: this.currentEvent.id,
        handleStatus: this.handleForm.handleStatus,
        handleRemark: this.handleForm.handleRemark,
        handlerId: 1, handlerName: '当前操作员'
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('处置成功');
          // 刷新详情
          mockGetEventDetail(this.currentEvent.id).then(r => {
            if (r.code === 200) this.currentEvent = r.data;
          });
          this.refreshAll();
        }
      });
    },
    contactDriver() {
      if (!this.currentEvent) return;
      this.$alert(`司机：${this.currentEvent.driverName}\n电话：${this.currentEvent.driverPhone}`, '联系司机', {
        confirmButtonText: '我知道了',
        type: 'info'
      });
    },
    openAddExempt() {
      if (!this.currentEvent) return;
      this.exemptForm = {
        id: this.currentEvent.id,
        routeId: this.currentEvent.routeId,
        name: `告警#${this.currentEvent.id}绕行点`,
        lng: this.currentEvent.maxLng,
        lat: this.currentEvent.maxLat,
        radiusM: 200
      };
      this.exemptDialogVisible = true;
    },
    submitExempt() {
      mockAddExemptPoint(this.exemptForm).then(res => {
        if (res.code === 200) {
          this.$message.success(`已将该点加入线路「${this.currentEvent.routeName}」的豁免点列表，后续不再告警`);
          this.exemptDialogVisible = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.stat-dashboard .el-col { margin-bottom: 0; }
.stat-card {
  display: flex; align-items: center; padding: 14px 16px;
  border: none !important;
  border-radius: 8px;
}
.stat-card :deep(.el-card__body) { padding: 0; display: flex; align-items: center; width: 100%; }
.stat-icon-wrap {
  width: 56px; height: 56px; border-radius: 14px;
  display: flex; align-items: center; justify-content: center;
  margin-right: 14px; font-size: 26px; color: #fff; flex-shrink: 0;
}
.stat-total .stat-icon-wrap { background: linear-gradient(135deg, #409EFF, #66B1FF); }
.stat-ongoing .stat-icon-wrap { background: linear-gradient(135deg, #F56C6C, #F78989); }
.stat-handled .stat-icon-wrap { background: linear-gradient(135deg, #67C23A, #85CE61); }
.stat-fp .stat-icon-wrap { background: linear-gradient(135deg, #E6A23C, #EEBE77); }
.stat-content { flex: 1; }
.stat-label { font-size: 12px; color: #909399; }
.stat-value { font-size: 26px; font-weight: 700; color: #303133; line-height: 1.3; margin: 2px 0; }
.stat-value .unit { font-size: 14px; font-weight: 400; color: #909399; margin-left: 2px; }
.stat-value.pulse { color: #F56C6C; animation: pulse 1.6s infinite; }
@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.55} }
.stat-trend { font-size: 12px; color: #67C23A; }
.stat-trend.warn { color: #E6A23C; }
.stat-trend.up::before { content: "↑ "; }

.card-header { display: flex; justify-content: space-between; align-items: center; }
.card-title { font-weight: 600; color: #303133; }
.card-title i { color: #409EFF; margin-right: 4px; }
.search-bar { display: flex; align-items: center; flex-wrap: wrap; }

.trend-chart { padding: 6px 4px 4px; }
.trend-svg { width: 100%; height: 200px; display: block; }
.dot-label { font-size: 10px; fill: #409EFF; font-weight: 600; }
.x-label { font-size: 10px; fill: #909399; }
.legend-row { display: flex; justify-content: center; gap: 18px; margin-top: 4px; font-size: 12px; color: #606266; }
.legend-item { display: inline-flex; align-items: center; }
.dot { display: inline-block; width: 10px; height: 10px; border-radius: 50%; margin-right: 4px; }
.dot.blue { background: #409EFF; }
.dot.orange { background: #E6A23C; }
.dot.green { background: #67C23A; }
.dot.gray { background: #909399; }

.top-list { padding: 0 4px; max-height: 218px; overflow-y: auto; }
.top-item { display: flex; align-items: center; padding: 8px 0; border-bottom: 1px dashed #f0f2f5; }
.top-item:last-child { border-bottom: none; }
.top-rank {
  width: 22px; height: 22px; border-radius: 6px; color: #fff; font-size: 12px; font-weight: 700;
  display: flex; align-items: center; justify-content: center; margin-right: 10px; flex-shrink: 0;
  background: #C0C4CC;
}
.top-rank.rk1 { background: #F56C6C; }
.top-rank.rk2 { background: #E6A23C; }
.top-rank.rk3 { background: #409EFF; }
.top-info { flex: 1; min-width: 0; }
.top-name { font-size: 13px; color: #303133; margin-bottom: 4px; font-weight: 500; }
.top-bar-wrap { height: 6px; background: #f0f2f5; border-radius: 3px; overflow: hidden; }
.top-bar { height: 100%; background: linear-gradient(90deg, #409EFF, #66B1FF); border-radius: 3px; transition: width .4s; }
.top-count { text-align: right; margin-left: 10px; flex-shrink: 0; }
.top-count .num { font-size: 16px; font-weight: 700; color: #F56C6C; }
.top-count .unit { font-size: 12px; color: #909399; margin-left: 2px; }
.top-count .sub { font-size: 11px; color: #909399; margin-top: 2px; }

.pie-wrap { padding: 4px; }
.pie-svg { width: 160px; height: 160px; display: block; margin: 0 auto; }
.pie-legend { margin-top: 8px; }
.pie-legend-item {
  display: flex; align-items: center; padding: 4px 0; font-size: 12px; color: #606266;
}
.color-box { width: 12px; height: 12px; border-radius: 3px; margin-right: 6px; flex-shrink: 0; }
.pl-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pl-pct { color: #303133; font-weight: 600; margin-left: 6px; }

.list-card { margin-bottom: 16px; }
.pagination-wrap { margin-top: 14px; display: flex; justify-content: flex-end; }
.plate-tag {
  display: inline-block; padding: 2px 8px; background: #ECF5FF; color: #409EFF;
  border: 1px solid #D9ECFF; border-radius: 4px; font-size: 12px; font-weight: 600;
}
.ongoing { color: #F56C6C; font-weight: 600; }
.dev-warn { color: #E6A23C; font-weight: 500; }
.dev-bad { color: #F56C6C; font-weight: 600; }
.dev-critical { color: #C0392B; font-weight: 700; }
.blink-dot {
  display: inline-block; width: 6px; height: 6px; border-radius: 50%;
  background: #F56C6C; margin-right: 4px; vertical-align: middle;
  animation: pulse 1.2s infinite;
}

/* 详情抽屉 */
.detail-root { padding-right: 6px; }
.event-header-card {
  border-radius: 10px; padding: 18px 20px; color: #fff; display: flex; justify-content: space-between;
  background: linear-gradient(135deg, #606266, #909399);
  margin-bottom: 16px;
}
.event-header-card.lv-1 { background: linear-gradient(135deg, #409EFF, #66B1FF); }
.event-header-card.lv-2 { background: linear-gradient(135deg, #E6A23C, #F0C78E); color: #5d460f; }
.event-header-card.lv-3 { background: linear-gradient(135deg, #F56C6C, #F89898); }
.ehc-level { margin-bottom: 8px; }
.level-badge {
  display: inline-block; padding: 2px 10px; border-radius: 12px; font-size: 12px; font-weight: 700;
  background: rgba(255,255,255,0.25); backdrop-filter: blur(4px);
}
.ehc-title { font-size: 20px; font-weight: 700; margin-bottom: 6px; }
.plate-big { font-family: 'Consolas', monospace; letter-spacing: 1px; }
.sep { margin: 0 8px; opacity: 0.6; }
.route { font-weight: 500; opacity: 0.95; }
.ehc-meta { font-size: 12px; opacity: 0.9; }
.meta-sep { margin: 0 8px; opacity: 0.5; }
.ehc-right { display: flex; gap: 20px; }
.ehc-stat { text-align: center; }
.ehc-num { font-size: 20px; font-weight: 700; }
.ehc-label { font-size: 11px; opacity: 0.85; margin-top: 2px; }

.section-title {
  font-weight: 600; font-size: 14px; color: #303133;
  margin: 18px 0 10px; padding-bottom: 6px;
  border-bottom: 1px dashed #ebeef5;
}
.section-title i { color: #409EFF; margin-right: 4px; }

.map-canvas-wrap {
  position: relative; height: 360px;
  border: 1px solid #ebeef5; border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
.map-empty-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  background: rgba(250,251,252,0.92);
  z-index: 5;
}
.map-empty-overlay i { font-size: 40px; margin-bottom: 10px; color: #c0c4cc; }
.map-legend {
  position: absolute; bottom: 10px; left: 10px; background: rgba(255,255,255,0.96);
  padding: 6px 12px; border-radius: 8px; font-size: 11px; color: #606266;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex; flex-wrap: wrap; gap: 10px;
  z-index: 10;
  border: 1px solid #ebeef5;
}
.lg-item { display: inline-flex; align-items: center; }
.lg-line { display: inline-block; width: 18px; height: 0; border-top: 3px solid; margin-right: 4px; border-radius: 2px; }
.lg-line.blue { border-color: #409EFF; }
.lg-line.gray { border-color: #909399; border-top-width: 2px; opacity: 0.8; }
.lg-line.red-bold { border-color: #F56C6C; border-top-width: 5px; }
.lg-buf { display: inline-block; width: 18px; height: 10px; background: rgba(64,158,255,0.15); border: 1px solid rgba(64,158,255,0.5); margin-right: 4px; border-radius: 2px; }
.lg-dot { display: inline-block; width: 10px; height: 10px; border-radius: 50%; margin-right: 4px; border: 1.5px solid #fff; box-shadow: 0 0 0 1px rgba(0,0,0,0.12); }
.lg-dot.green { background: #67C23A; }
.lg-dot.red { background: #F56C6C; }
.lg-dot.orange { background: #E6A23C; }

.replay-control {
  display: flex; align-items: center; margin-top: 12px;
  padding: 10px 14px; background: #F5F7FA; border-radius: 8px;
}
.play-time { font-family: Consolas, monospace; font-size: 13px; color: #606266; min-width: 50px; text-align: right; }

.curve-section { margin-top: 14px; }
.curve-svg { width: 100%; height: 120px; display: block; }
.th-label { font-size: 10px; fill: #F56C6C; }
.curve-meta { display: flex; justify-content: space-around; margin-top: 4px; font-size: 12px; color: #606266; }
.curve-meta b { color: #303133; }
.dev-bad { color: #F56C6C; font-weight: 600; }
.dev-ok { color: #67C23A; font-weight: 600; }

.addr-row { margin-top: 16px; }
.addr-card {
  display: flex; padding: 12px; background: #fafbfc;
  border: 1px solid #ebeef5; border-radius: 8px;
}
.addr-icon {
  width: 36px; height: 36px; border-radius: 10px; color: #fff;
  display: flex; align-items: center; justify-content: center;
  margin-right: 10px; flex-shrink: 0; font-size: 16px;
}
.addr-icon.start { background: linear-gradient(135deg, #67C23A, #85CE61); }
.addr-icon.max { background: linear-gradient(135deg, #F56C6C, #F78989); }
.addr-icon.end { background: linear-gradient(135deg, #909399, #A8ABB2); }
.addr-body { flex: 1; min-width: 0; }
.addr-label { font-size: 11px; color: #909399; }
.addr-text { font-size: 13px; color: #303133; margin: 2px 0; font-weight: 500; }
.addr-coord { font-size: 11px; color: #C0C4CC; font-family: Consolas, monospace; }

.handle-section { margin-top: 18px; }
.handle-form { padding-top: 4px; }
</style>
